import { useEffect, useRef, useState } from "react";
import { X, Send, Headset, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [sessionId] = useState(() => {
    let s = localStorage.getItem("tm_chat_sid");
    if (!s) {
      s = (crypto.randomUUID ? crypto.randomUUID() : `s${Date.now()}${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("tm_chat_sid", s);
    }
    return s;
  });
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Namaste! Main Seema, Trustmeds Pharma ki customer care se. Medicines, health ya order ke baare mein jo bhi puchna ho, bataiye!" },
  ]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const send = async () => {
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    setBusy(true);
    setMessages((m) => [...m, { role: "user", content: text }, { role: "assistant", content: "" }]);
    try {
      const resp = await fetch(`${API}/public/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, message: text }),
      });
      if (!resp.ok || !resp.body) throw new Error("bad response");
      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      let buf = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const events = buf.split("\n\n");
        buf = events.pop() || "";
        for (const ev of events) {
          const line = ev.split("\n").find((l) => l.startsWith("data:"));
          if (!line) continue;
          const payload = line.slice(5).trim();
          if (payload === "[DONE]") continue;
          try {
            const tok = JSON.parse(payload);
            if (tok.t) {
              setMessages((m) => {
                const n = [...m];
                n[n.length - 1] = { role: "assistant", content: (n[n.length - 1].content + tok.t).replace(/\*\*/g, "") };
                return n;
              });
            }
          } catch {}
        }
      }
    } catch {
      setMessages((m) => {
        const n = [...m];
        n[n.length - 1] = { role: "assistant", content: "Maaf kijiye, abhi jawab nahi de pa raha. Kripya 74288 11670 par call karein (8 AM - 10 PM)." };
        return n;
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {!open && (
        <button onClick={() => setOpen(true)} data-testid="chat-widget-open" aria-label="Chat with support"
          className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-50 w-14 h-14 rounded-full bg-[#064E3B] hover:bg-[#043B2C] text-white shadow-2xl flex items-center justify-center transition-transform hover:scale-105">
          <Headset className="w-6 h-6" />
        </button>
      )}
      {open && (
        <div className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-50 w-[92vw] max-w-sm bg-white border border-slate-200 rounded-3xl shadow-2xl flex flex-col overflow-hidden" style={{ height: "min(540px, 75vh)" }} data-testid="chat-widget-panel">
          <div className="bg-[#064E3B] text-white px-4 py-3 flex items-center gap-2.5 shrink-0">
            <div className="w-8 h-8 bg-white/15 rounded-full flex items-center justify-center relative"><Headset className="w-4.5 h-4.5" />
              <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-400 rounded-full border border-[#064E3B]" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-bold">Seema — Trustmeds Support</div>
              <div className="text-[10px] text-emerald-200 flex items-center gap-1">Online — abhi reply milega</div>
            </div>
            <button onClick={() => setOpen(false)} data-testid="chat-widget-close" className="p-1.5 hover:bg-white/10 rounded-full"><X className="w-4 h-4" /></button>
          </div>

          <div className="flex-1 overflow-y-auto p-3 space-y-2.5 bg-slate-50" data-testid="chat-messages">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-3.5 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-line ${
                  m.role === "user" ? "bg-[#064E3B] text-white rounded-br-sm" : "bg-white border border-slate-200 text-slate-700 rounded-bl-sm"
                }`}>
                  {m.content || (busy && i === messages.length - 1 ? <Loader2 className="w-4 h-4 animate-spin text-slate-400" /> : "")}
                </div>
              </div>
            ))}
            <div ref={endRef} />
          </div>

          <div className="p-3 border-t border-slate-100 bg-white shrink-0">
            <div className="flex items-center gap-2">
              <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
                placeholder="Type your message…" data-testid="chat-input" maxLength={500}
                className="flex-1 h-10 px-4 rounded-full border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
              <button onClick={send} disabled={busy || !input.trim()} data-testid="chat-send-btn"
                className="w-10 h-10 rounded-full bg-[#064E3B] hover:bg-[#043B2C] disabled:opacity-40 text-white flex items-center justify-center shrink-0">
                <Send className="w-4 h-4" />
              </button>
            </div>
            <p className="text-[10px] text-slate-400 mt-1.5 text-center">Medicines sirf doctor/pharmacist ki salah se lein. Urgent ho to 74288 11670 par call karein.</p>
          </div>
        </div>
      )}
    </>
  );
}
